import React, { useState } from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";
import "../Style/SideNavBar.css";

export const MENU_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    Icon: Feather.Airplay,
    url: "/",
  },
  {
    key: "vendor",
    label: "Vendor",
    Icon: Feather.User,
    url: "/vendor",
  },
  {
    key: "vehicle",
    label: "Vehicle",
    Icon: Feather.Truck,
    url: "/vehicle",
  },
  {
    key: "source",
    label: "Source",
    Icon: Feather.Link,
    children: [
      {
        key: "Km",
        label: "Km Source",
        Icon: Feather.Anchor,
        url: "/source",
      },
      {
        key: "Rate",
        label: "Rate Source",
        Icon: Feather.Map,
        url: "/fixedsource",
      },
    ],
  },
  {
    key: "destination",
    label: "Destination",
    Icon: Feather.Flag,
    children: [
      {
        key: "Km",
        label: " Km Destination",
        Icon: Feather.Navigation2,
        url: "/destination",
      },
      {
        key: "Fixed",
        label: "Fixed Destination",
        Icon: Feather.Tag,
        url: "/fixeddestination",
      },
    ],
  },
  {
    key: "distanceMaster",
    label: "DistanceMaster",
    Icon: Feather.MapPin,
    url: "/distancemaster",
  },
  {
    key: "rate",
    label: "Rate",
    Icon: Feather.DollarSign,
    children: [
      {
        key: "Km Rate",
        label: "Km Rate",
        Icon: Feather.Activity,
        url: "/rate",
      },
      {
        key: "fixedRate",
        label: "Fixed Rate",
        Icon: Feather.TrendingUp,
        url: "/fixedrate",
      },
    ],
  },

  {
    key: "advance",
    label: "Advance",
    Icon: Feather.Briefcase,
    children: [
      {
        key: "vendor advance",
        label: "Vendor Advance",
        Icon: Feather.Feather,
        url: "/advance",
      },
      {
        key: "vehicleadvance",
        label: "VehicleAdvance",
        Icon: Feather.Target,
        url: "/vehicleAdvance",
      },
    ],
  },
  // {
  //   key: "trip",
  //   label: "Trip",
  //   Icon: Feather.Navigation,
  //   url: "/trip",
  // },
  // {
  //   key: "payment",
  //   label: "Payment",
  //   Icon: Feather.FileText,
  //   url: "/payment",
  // },
  // {
  //   key: "VendorAdvanceDeduction",
  //   label: "VendorAdvance Deduction",
  //   Icon: Feather.MinusCircle,
  //   url: "/vendorAdvanceDeduction",
  // },
  {
    key: "wagon",
    label: "Wagon",
    Icon: Feather.Package,
    url: "/wagon",
  },
  {
    key: "contractor",
    label: "Contractor",
    Icon: Feather.UserCheck,
    url: "/contractor",
  },
  {
    key: "contractorPayment",
    label: "Contractor Payment",
    Icon: Feather.DollarSign,
    url: "/contractorPayment",
  },
  {
    key: "Bills",
    label: "Bills",
    Icon: Feather.FileText,
    children: [
      {
        key: "Add",
        label: "Add",
        Icon: Feather.FilePlus,
        url: "/billing",
      },
      {
        key: "View",
        label: "View",
        Icon: Feather.Eye,
        url: "/billingview",
      },
      {
        key: "Process",
        label: "Process",
        Icon: Feather.Play,
        url: "/process",
      },
    ],
  },

  {
    key: "report",
    label: "Report",
    Icon: Feather.BarChart2,
    children: [
      {
        key: "tripreport",
        label: "TripReport",
        Icon: Feather.Package,
        url: "/report/tripreport",
      },
      {
        key: "VendorAdvanceReport",
        label: "VendorAdvanceReport",
        Icon: Feather.Pocket,
        url: "/report/vendorAdvancereport",
      },
      {
        key: "BillReport",
        label: "Bill Report",
        Icon: Feather.CheckCircle,
        url: "/report/paymentreport",
      },
      {
        key: "VehicleAdvaceReport",
        label: "VehicleAdvance Report",
        Icon: Feather.Calendar,
        url: "/report/vehicleAdvance",
      },
      {
        key: "PaymentPreProcessingReport",
        label: "Payment Pre-Processing Report",
        Icon: Feather.RefreshCcw,
        url: "/report/Paymentpreprocess",
      },
      {
        key: "ownerPaymentList",
        label: "Owner Payment List",
        Icon: Feather.Book,
        url: "/report/ownerpayment",
      },
      {
        key: "wagon",
        label: "Wagon Report",
        Icon: Feather.Package,
        url: "/report/wagon",
      },
    ],
  },
  {
    key: "settings",
    label: "Settings",
    Icon: Feather.Settings,
    url: "/app_settings",
  },
];

const SideNavbarAdmin = ({ collapsed }) => {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleSubmenu = (key) => {
    setOpenMenu(openMenu === key ? null : key);
  };

  return (
    <aside
      className="main-sidebar elevation-4"
      style={{
        width: collapsed ? "80px" : "250px",
        transition: "width 0.3s",
        background: "linear-gradient(90deg, #012c68ff, #3f7d8dff)",
        position: "fixed",
        top: "0px",
        height: "calc(100vh - 60px),",
        overflow: "hidden",
        zIndex: 1030,
        left: 0,
      }}
    >
      <div className="sidebar">
        <div
          className="user-panel mt-2 pb-2 mb-3 d-flex justify-content-center"
          style={{ flexDirection: collapsed ? "column" : "row" }}
        >
          <div className="info">
            <Link
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: collapsed ? "10px 0" : "5px 25px",
              }}
            >
              <img
                src="/img/asa_white.png"
                style={{ width: collapsed ? "90%" : "60%" }}
                alt="College Logo"
              />
            </Link>
            <hr
              style={{
                width: "90%",
                margin: "5px auto",
                borderColor: "rgba(255,255,255,0.2)",
              }}
            />
          </div>
        </div>
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            data-accordion="false"
          >
            {MENU_ITEMS.map((menuItem) => (
              <li className="nav-item" key={menuItem.key}>
                {!menuItem.children ? (
                  <Link
                    to={menuItem.url || "#"}
                    className="nav-link d-flex align-items-center"
                    style={{
                      justifyContent: collapsed ? "center" : "flex-start",
                      padding: collapsed ? "10px 0" : "10px 20px",
                      transition: "all 0.3s",
                      width: "100%",
                    }}
                  >
                    {menuItem.Icon && <menuItem.Icon size={20} />}
                    {!collapsed && (
                      <span style={{ color: "white", marginLeft: "10px" }}>
                        {menuItem.label}
                      </span>
                    )}
                  </Link>
                ) : (
                  <>
                    <div
                      className="nav-link d-flex align-items-center"
                      onClick={() => toggleSubmenu(menuItem.key)}
                      style={{
                        justifyContent: collapsed ? "center" : "flex-start",
                        padding: collapsed ? "10px 0" : "10px 20px",
                        cursor: "pointer",
                      }}
                    >
                      {menuItem.Icon && <menuItem.Icon size={20} />}
                      {!collapsed && (
                        <>
                          <span
                            style={{
                              color: "white",
                              marginLeft: "10px",
                              flexGrow: 1,
                            }}
                          >
                            {menuItem.label}
                          </span>
                          {openMenu === menuItem.key ? (
                            <Feather.ChevronDown size={18} color="white" />
                          ) : (
                            <Feather.ChevronRight size={18} color="white" />
                          )}
                        </>
                      )}
                    </div>
                    {!collapsed && openMenu === menuItem.key && (
                      <ul
                        className="nav flex-column"
                        style={{ marginLeft: "30px" }}
                      >
                        {menuItem.children.map((child) => (
                          <li className="nav-item" key={child.key}>
                            <Link
                              to={child.url}
                              className="nav-link d-flex align-items-center"
                            >
                              {child.Icon && <child.Icon size={16} />}
                              <span
                                style={{ color: "white", marginLeft: "10px" }}
                              >
                                {child.label}
                              </span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
};
export default SideNavbarAdmin;
